import React, { type FunctionComponent } from 'react'
import { type FormContextValues } from 'react-hook-form'
import { collectionFormTileOptions } from 'domains/collections/components/collections-form/utils/collectionFormImageOptions'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'
import { CollectionsFormSection } from 'domains/collections/components/collections-form/components/form-section/CollectionsFormSection'
import { CollectionsFormImageInput } from 'domains/collections/components/collections-form/components/form-image/CollectionsFormImageInput'
import { CollectionsFormCheckbox } from 'domains/collections/components/collections-form/components/form-input/CollectionsFormCheckbox'
import { CollectionsFormRow } from 'domains/collections/components/collections-form/components/form-row/CollectionsFormRow'
import { collectionsFormTestIds } from 'domains/collections/components/collections-form/utils/collectionsForm.utils'

interface CollectionsTileProps {
  register: FormContextValues<CollectionsFormData>['register']
  errors: FormContextValues<CollectionsFormData>['errors']
  control: FormContextValues<CollectionsFormData>['control']
  getValues: FormContextValues<CollectionsFormData>['getValues']
  showFormFragment: boolean
}

export const CollectionsTile: FunctionComponent<CollectionsTileProps> = ({
  register,
  errors,
  getValues,
  control,
  showFormFragment,
}) => (
  <CollectionsFormSection titleId="collectionsDomain.collectionsForm.section.tiles">
    <CollectionsFormRow>
      <CollectionsFormCheckbox
        name="showTileFragment"
        identifier="showTileFragment"
        labelId="collectionsDomain.collectionsForm.section.tiles.toggleLabel"
        control={control}
        data-testid={collectionsFormTestIds.tileToggle}
      />
    </CollectionsFormRow>

    {showFormFragment && (
      <CollectionsFormImageInput
        {...collectionFormTileOptions}
        defaultUrl={getValues(collectionFormTileOptions.identifier)}
        ref={register({ required: true })}
        errors={errors}
      />
    )}
  </CollectionsFormSection>
)
